import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './messages'

Vue.use(VueI18n)

// Local navigator language
const localLang = window.navigator.userLanguage || window.navigator.language

// function that check if cookie exist by name
const hasCookie = (cookieName) => !!localStorage.getItem(cookieName)

// Function that get cookie by name
const getCookie = (cookieName) => localStorage.getItem(cookieName)

// Function that set cookie by name and value
const setCookie = (cookieName, value) => localStorage.setItem(cookieName, value)

// Parse lang with 2 character for i18n
const parseLang = (lang) => lang.substring(0, 2)

// Verify if cookie has lang, if not set cookie with locale language
!hasCookie('Stampytlang') && setCookie('Stampytlang', parseLang(localLang))

const i18n = new VueI18n({
  fallbackLocale: 'fr', // set fallback locale
  messages // set locale messages
})

export const i18nWithKeycloak = (store) => {
  const keycloakLang = store.state.user && store.state.user.locale

  i18n.locale = getCookie('Stampytlang') || keycloakLang

  return i18n
}

export default i18n
